import { CredentialsAdapters } from '../adapters';
import { CredentialsApi } from '../clients';
import type { IAuthorization } from '../types';

export const getAuthorizationCredentials = async (
  professionalId: string,
): Promise<IAuthorization[]> => {
  const response = await CredentialsApi.getAuthorizationCredentials(professionalId);

  return CredentialsAdapters.toAuthorizationList(response);
};
